import { useAuth } from '@e2m-customer-portal/hooks';
import { useEffectOnce } from 'react-use';

export const Login = {
  RedirectToAuthServer: (): null => {
    const { login } = useAuth();
    useEffectOnce(() => {
      login();
    });

    return null;
  },

  RedeemAuthServerCode: (): null => {
    const { redeemAuthCode } = useAuth();
    useEffectOnce(() => {
      redeemAuthCode();
    });

    return null;
  },
};
